import s from './TasteFuture.module.scss'
import React, { ReactElement } from 'react'
import cn from 'classnames'

type WidgetConfiguration = {
    widgetConfiguration: { [key: string]: string }
    children?: ReactElement[]
}
const TasteFutureGroup = (props: WidgetConfiguration) => {
    const {
        widgetConfiguration: { heading, 'background-color': backgroundColor },
        children
    } = props
    const enhancedChildren = children?.map((item) => {
        item.props.data.childLength = children?.length
        return item
    })

    return (
        <div style={{ backgroundColor: backgroundColor }}>
            <div className={s.FutureCardGroup}>
                <h3 className={s.mainHeading}>{heading}</h3>
                <div
                    className={cn(
                        s.FutureCardGroupChildren,
                        'FutureCardLength',
                        `FutureCardLength-${children?.length}`
                    )}
                >
                    {enhancedChildren}
                </div>
            </div>
        </div>
    )
}
export default TasteFutureGroup
